var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./DetalhesRegistro.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-8541efac\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./DetalhesRegistro.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Imoveis/Detalhes/DetalhesRegistro.vue
// module id = 935
// module chunks = 1